import Icon from '../components/Icon.vue'

Icon.register({
  retweet: {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M629.7 343.6l-100.7 100.7c-9.4 9.4-24.6 9.4-33.9 0l-100.7-100.7c-9.4-9.4-9.4-24.6 0-33.9l10.8-10.8c9.6-9.6 25.1-9.3 34.4 0.5l40.4 42.8v-182.1h-187.5c-5.5 0-13.1-3.1-17-7l-16-16c-15.1-15.1-4.4-41 17-41h243.5c13.3 0 24 10.7 24 24v222.1l40.4-42.8c9.3-9.8 24.9-10.1 34.4-0.5l10.8 10.8c9.4 9.4 9.4 24.6 0 33.9zM364.5 359l16 16c15.1 15.1 4.4 41-17 41h-243.5c-13.3 0-24-10.7-24-24v-222.1l-40.4 42.8c-9.3 9.8-24.9 10.1-34.4 0.5l-10.8-10.8c-9.4-9.4-9.4-24.6 0-33.9l100.7-100.7c9.4-9.4 24.6-9.4 33.9 0l100.7 100.7c9.4 9.4 9.4 24.6 0 33.9l-10.8 10.8c-9.6 9.6-25.1 9.3-34.4-0.5l-40.4-42.8v182.1h187.5 0c5.5 0 13.1 3.1 17 7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/retweet.js
// module id = 1842
// module chunks = 0